"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.modalController = undefined;
exports.setupModals = setupModals;

var _animation = require("../animation");

var _Observable = require("rxjs/Observable");

require("rxjs/add/observable/fromEvent");

require("rxjs/add/observable/merge");

require("rxjs/add/operator/filter");

require("rxjs/add/operator/map");

require("rxjs/add/operator/first");

var _form = require("../form");

// import { fromEvent, merge } from 'rxjs'
// import { filter, map, first } from 'rxjs/operators'
var modalController = exports.modalController = {
    modalContainer: null,
    modals: {},
    buttons: {},
    currentOpenModal: null,
    template: null,
    lastFocus: null,
    iconPath: '',
    openModal: openModal,
    closeModal: closeModal,
    addModal: addModal
};

function setupModals() {
    var container = document.querySelector('.js-modal-container');
    if (!container) {
        return;
    }

    var buttonEls = document.querySelectorAll('button[data-modal-id]');
    var buttons = Array.from(buttonEls);
    modalController.buttons = buttons.reduce(function (acc, btn) {
        btn.setAttribute('aria-haspopup', 'dialog');
        btn.setAttribute('aria-expanded', 'false');

        var id = btn.dataset.modalId;
        if (!acc[id]) {
            acc[id] = [];
        }

        acc[id].push(btn);
        return acc;
    }, {});

    modalController.iconPath = container.dataset.iconPath || '/images/svgicons.svg';

    modalController.openModal = modalController.openModal.bind(modalController);
    modalController.closeModal = modalController.closeModal.bind(modalController);
    modalController.addModal = modalController.addModal.bind(modalController);

    modalController.template = document.querySelector('.js-modal-template');
    if (!modalController.template) {
        return;
    }
    modalController.template = modalController.template.innerHTML;

    modalController.modalContainer = container;
    var modals = modalController.modalContainer.querySelectorAll('[data-modal-item-id]');
    modals = Array.from(modals);
    modals.forEach(function (el) {
        var id = el.dataset.modalItemId;
        modalController.addModal({ id: id, content: el });
    });

    if (typeof window.modals !== 'undefined') {
        window.modals.forEach(function (el) {
            if (el.content) {
                modalController.addModal(el);
            }
            if (el.open) {
                modalController.openModal(el.id);
            }
        });
    }
    setupEvents();
}

function setupEvents() {
    _Observable.Observable.fromEvent(document, 'click').filter(function (el) {
        return !!el.target.dataset.modalId;
    }).map(function (el) {
        return el.target.dataset.modalId;
    }).subscribe(modalController.openModal);

    _Observable.Observable.merge(_Observable.Observable.fromEvent(document, 'click').filter(function (el) {
        return el.target.classList.contains('js-modal-close');
    }));

    _Observable.Observable.fromEvent(modalController.modalContainer, 'click').subscribe(modalController.closeModal);

    var keyDown = _Observable.Observable.fromEvent(modalController.modalContainer, 'keydown');

    keyDown.filter(function (evt) {
        return evt.key === 'Tab' && modalController.currentOpenModal;
    }).subscribe(function (evt) {
        var focusEls = modalController.currentOpenModal.focusEls;

        if (focusEls.length === 1) {
            evt.preventDefault();
            return;
        }

        var currentActive = document.activeElement;
        var firstFocusable = focusEls[0];
        var lastFocusable = focusEls[focusEls.length - 1];

        if (evt.shiftKey) {
            if (currentActive === firstFocusable) {
                evt.preventDefault();
                lastFocusable.focus();
            }
        } else {
            if (currentActive === lastFocusable) {
                evt.preventDefault();
                firstFocusable.focus();
            }
        }
    });

    keyDown.filter(function (evt) {
        return evt.key === 'Escape' && modalController.currentOpenModal;
    }).subscribe(modalController.closeModal);
}

function openModal(modalID) {
    var _this = this;

    if (!this.modals[modalID]) {
        console.warn('No Modal find with id: ' + modalID);
        return;
    }

    this.lastFocus = document.activeElement;
    var _modals$modalID = this.modals[modalID],
        element = _modals$modalID.element,
        firstFocusElements = _modals$modalID.firstFocusElements;


    this.modalContainer.hidden = false;
    element.hidden = false;
    document.body.classList.add('h-lock');

    if (this.buttons[modalID] && this.buttons[modalID].length) {
        this.buttons[modalID].forEach(function (btn) {
            btn.setAttribute('aria-expanded', 'true');
        });
    }

    requestAnimationFrame(function () {
        if (!_this.modalContainer.classList.contains('is-active')) {
            _this.modalContainer.classList.add('is-active');
        }

        if (_this.currentOpenModal) {
            if (_this.currentOpenModal.element === element) {
                return;
            } else {
                _this.currentOpenModal.element.classList.remove('is-active');
                (0, _animation.transitionEnd)(_this.currentOpenModal.element).first().subscribe(function () {
                    _this.currentOpenModal.element.hidden = true;
                });
            }
        }

        _this.currentOpenModal = _this.modals[modalID];
        element.classList.add('is-active');
        firstFocusElements.focus();
    });
}

function closeModal() {
    var _this2 = this;

    var _currentOpenModal = this.currentOpenModal,
        element = _currentOpenModal.element,
        id = _currentOpenModal.id;


    this.modalContainer.classList.remove('is-active');

    if (this.buttons[id] && this.buttons[id].length) {
        this.buttons[id].forEach(function (btn) {
            btn.setAttribute('aria-expanded', 'false');
        });
    }

    element.classList.remove('is-active');
    this.currentOpenModal = null;
    (0, _animation.transitionEnd)(element).first().subscribe(function () {
        _this2.modalContainer.hidden = true;
        element.hidden = true;
    });

    this.lastFocus.focus();
    document.body.classList.remove('h-lock');
}

function addModal(_ref) {
    var id = _ref.id,
        content = _ref.content,
        _ref$header = _ref.header,
        header = _ref$header === undefined ? '' : _ref$header,
        _ref$icon = _ref.icon,
        icon = _ref$icon === undefined ? '' : _ref$icon;

    if (modalController.modals[id]) {
        return;
    }

    var element = void 0;
    if (typeof content === 'string') {
        element = createModal(id, content, header, icon);
    } else {
        element = content;
    }

    var focusableElements = element.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    focusableElements = Array.from(focusableElements);

    modalController.modals[id] = {
        id: id,
        element: element,
        focusEls: focusableElements,
        firstFocusElements: focusableElements[0]
    };

    _Observable.Observable.fromEvent(element, 'click').filter(function (evt) {
        return evt.target.classList.contains('js-modal-close');
    }).subscribe(modalController.closeModal);

    var hasInputGroup = element.querySelector('.js-hover-label');
    hasInputGroup && (0, _form.hoverLabel)();

    element.addEventListener('click', function (evt) {
        evt.stopPropagation();
    });

    if (element.classList.contains('is-active')) {
        modalController.currentOpenModal = modalController.modals[id];
    }
}

function createModal(id, content, header, icon) {
    var iconHtml = '';
    if (icon) {
        iconHtml = "<svg><use xlink:href=\"" + modalController.iconPath + "#" + icon + "\" /></svg>";
    }

    var html = modalController.template.replace(/{id}/g, id).replace(/{header}/g, header).replace(/{content}/g, content).replace(/{icon}/g, iconHtml);
    var div = document.createElement('div');
    div.innerHTML = html;
    modalController.modalContainer.appendChild(div.firstElementChild);
    return modalController.modalContainer.querySelector('[data-modal-item-id=' + id + ']');
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/modal.js
// module id = ./resources/assets/js/src/ui/modal.js
// module chunks = 0